import type { IDisposable } from './IDisposable';

export class DisposablesBasket implements IDisposable {
  private readonly _disposables = new Array<IDisposable>();

  public add(...disposables: Array<IDisposable>): void {
    this._disposables.push(...disposables);
  }

  // IDisposable
  public dispose(): void {
    for (const disposable of this._disposables) {
      disposable.dispose();
    }
    this._disposables.length = 0;
  }
}
